// ##############################
// // // ValidationForms view styles
// #############################

import {
  cardTitle,
  dangerColor,
  actionButton,
  actionIconButton,
  dangerActionButton,
  dangerActionIconButton,
} from "assets/jss/material-dashboard-pro-react.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const validationFormsStyle = {
  ...customCheckboxRadioSwitch,
  cardTitle: {
    ...cardTitle,
    color: "#FFFFFF"
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  formCategory: {
    marginBottom: "0",
    color: "#999999",
    fontSize: "14px",
    padding: "10px 0 10px"
  },
  center: {
    textAlign: "center"
  },
  justifyContentCenter: {
    justifyContent: "center"
  },
  registerButton: {
    float: "right"
  },
  danger: {
    color: dangerColor + "!important"
  },
  actionButton,
  dangerActionButton,
  actionIconButton,
  dangerActionIconButton,
};

export default validationFormsStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx
